import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";
import { Observable } from "rxjs";
import { EstruturaRetornoDadosOutputDto } from "../domain/DTOs/output/estrutura-retorno-dados.output.dto";
import { SobreJornalOutputDto } from "../domain/DTOs/output/sobre/sobre-jornal.output.dto";

@Injectable()
export class SobreService {

  constructor(private baseService: BaseService) {}

  public obterSobre(): Observable<EstruturaRetornoDadosOutputDto<SobreJornalOutputDto>> {
    return this.baseService.get(`Sobre/ObterSobre`);
  }

   public obterArquivoPoliticaPrivacidade(): Observable<EstruturaRetornoDadosOutputDto<string>> {
    return this.baseService.get(`Sobre/ObterPoliticaPrivacidade`);
  }
}